/**
 * `productId` MUST equal the backend module's id in huaca/src/manifest.ts — it is the key for route
 * paths (/api/{productId}/…), permissions ({productId}:…), seats and plans. A mismatch here does not
 * fail loudly; it makes every gate check quietly refer to a product that does not exist.
 */
const API_BASE = import.meta.env.VITE_API_BASE;

if (!API_BASE) {
  throw new Error('VITE_API_BASE is not set — the app cannot reach the Huaca API.');
}

export const config = {
  apiBase: API_BASE as string,
  /** This module's own origin — logins and invites return HERE, not to a central app. */
  webOrigin: window.location.origin,
  productId: 'tenders',
  productName: 'מכרזים',
} as const;
